export const IMAGES = {
  morningFocus: "https://static.prod-images.emergentagent.com/jobs/c07a61d9-3aaf-45fa-874f-d6d93e586d79/images/5d5c7f680567f5354eab2116f977e47859743f444cd066afd49f5efe3626c8d9.jpeg",
  deepFlow: "/images/deep-flow.jpg",
  eveningCalming: "/images/evening-calming.jpg",
  matchaZen: "/images/matcha-zen.jpg",
  duoRituel: "https://static.prod-images.emergentagent.com/jobs/c07a61d9-3aaf-45fa-874f-d6d93e586d79/images/3257d16f468ef780f3e3e8f52f8082abf18544cc8849b796676fdc21fbcdfe20.jpeg",
  heroLifestyle: "/images/hero-lifestyle.jpg",
  ritualTexture: "https://static.prod-images.emergentagent.com/jobs/c07a61d9-3aaf-45fa-874f-d6d93e586d79/images/c9c39171bf9903eff3c6d0c08c2534ce6f6b822d92127afe3725b2e1216711c2.jpeg",
};

// Catalogue vivant : rempli depuis l'API (/api/products) par StoreContext.
export const PRODUCTS = [];
export const hydrateProducts = (list) => { PRODUCTS.splice(0, PRODUCTS.length, ...list); };

export const FREE_SHIPPING_THRESHOLD = 50;
export const SHIPPING_COST = 7;
